export class UsuarioEmpresa
{
    Usuario : string;
    EmpresaId : number;
}